<template>
  <div class="login-container" style="
      width: 350px;
      margin: 100px auto;
      padding: 20px;
      border: 1px solid #ccc;
      border-radius: 8px;
      background: #fff;
    ">
    <h2 style="text-align: center; margin-bottom: 20px">System Login</h2>
    <el-form :model="loginForm" :rules="loginRules" ref="loginFormRef" label-width="80px">
      <el-form-item label="username" prop="username">
        <el-input v-model="loginForm.username" placeholder="Please enter the username"></el-input>
      </el-form-item>
      <el-form-item label="password" prop="password">
        <el-input v-model="loginForm.password" type="password" placeholder="Please enter the password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleLogin" style="width: 100%">login</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Message } from "element-ui";
import { login } from "../api/auth";

export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        role: "",
      },
      loginRules: {
        username: [
          { required: true, message: "Please enter the username", trigger: "blur" },
        ],
        password: [{ required: true, message: "Please enter the password", trigger: "blur" }],
        // role: [{ required: true, message: "请选择角色", trigger: "change" }],
      },
    };
  },
  methods: {
    handleLogin() {
      this.$refs.loginFormRef.validate(async (isValid) => {
        if (isValid) {
          // 模拟登录成功，存储用户信息到localStorage
          const result = await login(this.loginForm);

          if (result.code !== 200) {
            Message.error(result.message);
            return;
          }

          localStorage.setItem(
            "userInfo",
            JSON.stringify({
              username: result.data.username,
              role: result.data.role,
            })
          );
          Message.success("Login successful");
          // 根据角色跳转对应页面
          if (result.data.role === "customer") {
            this.$router.push("/customer-order-list");
          } else {
            this.$router.push("/admin-order-list");
          }
        } else {
          Message.error("Please complete your login information");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.login-container {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
</style>